import { render, staticRenderFns } from "./CancelledNotice.vue?vue&type=template&id=e6b70612&"
import script from "./CancelledNotice.vue?vue&type=script&lang=js&"
export * from "./CancelledNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports